//*************************************************/
// MENU BUTTON
// Displays a customizable button that opens a full-screen menu when clicked used Antd Drawer.
//*************************************************/

import { Drawer } from "@dreambigger/design-system/src";
import { useState } from "react";
import Menu from "./Menu";
import { CaretDownFill } from "react-bootstrap-icons";
import { MenuItem } from "./Menu";

type MenuButtonProps = {
  className?: string;
  disableDefaultClasses?: boolean;
  label?: React.ReactNode;
  style?: React.CSSProperties;
  menuTitle?: string;
  menuTitleClassName?: string;
  items: MenuItem[];
  setItems?: any;
  activeItem?: string;
  menuClassName?: string;
  defaultCollapsedState?: "open" | "closed";
  filterLabel?: string;
  filterInitiallyChecked?: boolean;
  addItemLabel?: string;
  addItemPlaceholder?: string;
  showCaret?: boolean;
  caretClassName?: string;
  onAdd?: (args?: any) => any;
  onAddClick?: () => void;
  onSelect?: (args?: any) => any;
  onFilterChange?: (args?: any) => any;
};

const MenuButton = ({
  label = "Menu",
  className = "bg-white b-gray-5 ba pa-3 pointer",
  disableDefaultClasses,
  style,
  menuTitle,
  menuTitleClassName = "f-5 fwb pa-3",
  items,
  activeItem,
  menuClassName,
  filterLabel,
  filterInitiallyChecked,
  addItemLabel,
  addItemPlaceholder,
  showCaret,
  caretClassName = "gray-7 ml-2",
  onAdd,
  onAddClick,
  onSelect,
  onFilterChange,
}: MenuButtonProps) => {
  const [showMenu, setShowMenu] = useState(false);
  const defaultClasses = "bg-white b-gray-4 ba pa-3 pointer";

  return (
    <>
      {/* Menu Button */}
      <button
        className={`${
          disableDefaultClasses !== true && defaultClasses
        } ${className}`}
        style={style}
        onClick={() => setShowMenu(true)}
      >
        <div className="flex items-center justify-between">
          {label}
          {showCaret !== false && <CaretDownFill className={caretClassName} />}
        </div>
      </button>
      {/* Fullscreen Drawer that opens when menu button is clicked */}
      <Drawer
        visible={showMenu}
        footer={null}
        onClose={() => setShowMenu(false)}
        placement="top"
        height="100%"
      >
        <Menu
          title={menuTitle}
          titleClassName={menuTitleClassName}
          items={items}
          activeItem={activeItem}
          onSelect={(args: any) => {
            onSelect && onSelect(args); // Passed-in function
            setShowMenu(false); // Close the menu
          }}
          onAdd={(args: any) => {
            onAdd && onAdd(args); // Passed-in function
            setShowMenu(false); // Close the menu
          }}
          onAddClick={
            onAddClick
              ? () => {
                  onAddClick();
                  setShowMenu(false);
                }
              : undefined
          }
          onFilterChange={onFilterChange}
          className={menuClassName}
          filterLabel={filterLabel}
          filterInitiallyChecked={filterInitiallyChecked}
          addItemLabel={addItemLabel}
          addItemPlaceholder={addItemPlaceholder}
        />
      </Drawer>
    </>
  );
};

export default MenuButton;
